import { render } from "./WechatSettings.vue?vue&type=template&id=62a2aa4d&scoped=true"
import script from "./WechatSettings.vue?vue&type=script&lang=js"
export * from "./WechatSettings.vue?vue&type=script&lang=js"

import "./WechatSettings.vue?vue&type=style&index=0&id=62a2aa4d&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a2aa4d"]])

export default __exports__